/**
 * GraphQL mutation for submitting feedback on a moderation case
 */

import { gql } from '@apollo/client';

export const SUBMIT_CASE_FEEDBACK = gql`
  mutation SubmitCaseFeedback($input: CaseFeedbackInput!) {
    submitCaseFeedback(input: $input) {
      id
      communityId
      topicName
      subjectId
      caseId
      pk
      report {
        communityId
        topicName
        subjectId
        timestamp
        contents {
          contentId
          contentType
          data
          labels {
            labels {
              name
              confidence
            }
            source
          }
        }
      }
      status
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
